module.exports = __webpack_public_path__ + "9d7a0a37247cd8b7e73c65dce35ceb16.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/roguecompany/highcastle.png
// module id = 438
// module chunks = 0